import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Grid, PaymentLogo, Typography } from 'gu-ui-kit'
import styles from 'modules/Billing/PaymentOrder/payment-order.module.scss'
import clsx from 'clsx'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import formatMoney from 'utils/formatMoney'
import GridSpinner from 'components/UI/GridSpinner'
import { ReactComponent as DoneIcon } from 'images/icon-components/done.svg'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'

const PaymentOrder = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const {
    paymentOrder: {
      loading,
      loadFailed,
      user_name,
      account_login,
      payment_method,
      payment_amount,
      currency,
      status,
    },
  } = useSelector((state) => ({
    paymentOrder: state['payment-order'],
  }))

  const [redirectUrl, setRedirectUrl] = useState(null)

  useEffect(
    () =>
      new Promise((resolve, reject) => {
        dispatch({
          type: 'PAYMENT_ORDERS/FETCH_INFO',
          payload: { id },
          meta: { resolve, reject },
        })
      })
        .catch(() => {
          dispatch({
            type: 'PAYMENT_ORDERS/SET_ORDER_INFO',
            payload: { loadFailed: true },
          })
        })
        .finally(() =>
          dispatch({
            type: 'PAYMENT_ORDERS/SET_ORDER_INFO',
            payload: { loading: false },
          }),
        ),
    [],
  )

  useEffect(() => {
    global.getBack = () => {
      redirectUrl && (global.location.href = redirectUrl)
    }
  }, [redirectUrl])

  return (
    <Container
      className={styles['wrapper']}
      display={'flex'}
      flexAlign={'center'}
      flexJustify={'center'}
      flexDirection={'column'}
    >
      <Container
        className={styles['container']}
        display={'flex'}
        flexAlign={'center'}
        flexDirection={'column'}
      >
        {IS_APP_PRODUCT_GETUNIQ ? (
          <PaymentLogo
            name={'getuniq'}
            color={'black'}
            width={188}
            height={64}
            className={styles['logo']}
          />
        ) : (
          <PaymentLogo name={'adsimple'} width={188} className={styles['logo']} />
        )}

        {status === 'paid' && <DoneIcon width={180} height={180} className={styles['done-icon']} />}

        <Typography variant={'h6'} weight={'bold'} className={styles['header']}>
          {t('payment_order::header', { context: status })}
        </Typography>
        <Typography
          variant={'p10'}
          noMargin
          color={'Label-Secondary'}
          className={styles['getuniq-description']}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: t('payment_order::description', {
                context: status,
                href: global.location.origin,
              }),
            }}
          />
        </Typography>
        <Grid className={styles['reciept__container']}>
          {loading || loadFailed ? (
            <GridSpinner width={18} />
          ) : (
            <>
              <Grid gap={[4, 16]}>
                <Col className={styles['reciept__label']} s="12" xs="6">
                  <div>{t('payment_order::labels.user_name')}</div>
                </Col>
                <Col className={styles['reciept__value']} s="12" xs="6">
                  {user_name}
                </Col>
              </Grid>
              {account_login && (
                <Grid gap={[4, 16]}>
                  <Col className={styles['reciept__label']} s="12" xs="6">
                    <div>{t('payment_order::labels.account_login')}</div>
                  </Col>
                  <Col className={styles['reciept__value']} s="12" xs="6">
                    {account_login}
                  </Col>
                </Grid>
              )}
              <Grid gap={[4, 16]}>
                <Col className={styles['reciept__label']} s="12" xs="6">
                  <div>{t('payment_order::labels.payment_method')}</div>
                </Col>
                <Col className={styles['reciept__value']} s="12" xs="6">
                  {t(`billing::methods.${payment_method}`)}
                </Col>
              </Grid>
            </>
          )}
          <hr className={styles['reciept__hr']} />
          {loading ? (
            <GridSpinner width={18} />
          ) : (
            <Grid className={styles['summary']} gap={[4, 16]}>
              <Col
                className={clsx(styles['reciept__label'], styles['summary__label'])}
                s="12"
                xs="6"
              >
                <span>{t('payment_order::labels.payment_amount')}</span>
              </Col>
              <Col
                className={clsx(styles['summary__amount'], styles['reciept__value'])}
                s="12"
                xs="6"
              >
                {payment_amount && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: formatMoney(payment_amount, currency),
                    }}
                  />
                )}
              </Col>
            </Grid>
          )}
        </Grid>
        <Container
          display={'flex'}
          flexDirection={'column'}
          className={styles['button__container']}
        >
          {status === 'new' && (
            <Button
              disabled={loading}
              variant={'primary'}
              size={'l'}
              fullWidth={true}
              className={styles['button']}
              component={'a'}
              onClick={() => {
                const windowReference = window.open('', '_blank')
                new Promise((resolve, reject) => {
                  dispatch({
                    type: 'PAYMENT_ORDERS/FETCH_PAY_URL',
                    payload: { id },
                    meta: { resolve, reject },
                  })
                })
                  .then(({ redirect_url, pay_url }) => {
                    setRedirectUrl(redirect_url)
                    windowReference.location = pay_url
                  })
                  .catch(() => {
                    if (windowReference) {
                      windowReference.close()
                    }
                  })
              }}
            >
              {t('payment_order::buttons.pay')}
            </Button>
          )}
          <Button
            className={styles['button']}
            variant={status === 'paid' ? 'primary' : 'ghost'}
            grey={status !== 'paid'}
            size={'l'}
            fullWidth={true}
            component={'a'}
            href={global.location.origin}
          >
            {t('payment_order::buttons.back_to_main')}
          </Button>
        </Container>
      </Container>
    </Container>
  )
}

export default PaymentOrder
